import Axios from "axios";

export const sendOtp = ({ mobileNumber, turnstileToken }) =>
  Axios.post(
    `${process.env.REACT_APP_DIRECTUS_INSTANCE_PATH}/user-auth/qa/otp/send`,
    {
      send_to: mobileNumber,
      requested_from: "SST-GW",
    },
    {
      headers: {
        "cf-turnstile-response": turnstileToken,
      },
      withCredentials: true,
    },
  );

export const verifyOtp = ({ otp, mobileNumber, callbackFn }) =>
  Axios.post(
    `${process.env.REACT_APP_DIRECTUS_INSTANCE_PATH}/user-auth/qa/otp/verify`,
    {
      sent_to: mobileNumber,
      input: otp,
      requested_from: "SST-GW",
    },
    {
      withCredentials: true,
    },
  );
